<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M3.333 14.667c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 13.333V10.3l1.833-2.083.95.95-1.333 1.5h9.1L11.25 9.2l.95-.95L14 10.3v3.033c0 .367-.13.68-.392.942a1.284 1.284 0 0 1-.941.392H3.333Zm0-1.334h9.334V12H3.333v1.333Zm3.75-3.75-2.35-2.35a1.252 1.252 0 0 1-.375-.941 1.31 1.31 0 0 1 .392-.942l3.267-3.267a1.35 1.35 0 0 1 .95-.4c.377-.01.694.111.95.367l2.35 2.35c.255.256.389.567.4.933.01.367-.111.678-.367.934L8.967 9.6c-.256.256-.57.38-.942.375a1.31 1.31 0 0 1-.942-.392Zm4.25-4.233L8.983 3l-3.3 3.3 2.35 2.35 3.3-3.3Z"
        />
    </svg>
</template>

<script setup lang="ts">
type VoteIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<VoteIconProps>();
</script>
